<template>
  <v-container grid-list-xl fluid class="pt-0">

    <v-toolbar dark color="primary">
      <v-spacer></v-spacer>
      <v-layout row wrap>
        <v-spacer></v-spacer>
        <v-flex sm3>
          <v-text-field color="white" placeholder="xx.xxx.xxx-x" mask="##.###.###-N" v-on:keyup.enter="getInstallationPersonalInfo" dark clearable hide-details label="Rut" v-model='filter.rut'></v-text-field>
        </v-flex>
        <v-flex sm4>
          <v-text-field color="white" placeholder="Nombre" v-on:keyup.enter="getInstallationPersonalInfo" dark clearable hide-details label="Nombre" v-model='filter.employeeFullName'></v-text-field>
        </v-flex>
      </v-layout>
      <v-btn icon flat @click="getInstallationPersonalInfo"><v-icon medium>search</v-icon></v-btn>
    </v-toolbar>

    <v-data-table :headers="headers" :items="items" :loading="loading" class="elevation-1" rows-per-page-text='Mostrar' :rows-per-page-items="[10, 50]">
      <template v-slot:items="props">
        <td>{{ props.item.companyName }}</td>
        <td>{{ props.item.full_name }}</td>
        <td>{{ props.item.rut_formated }}</td>
        <td>{{ props.item.email }}</td>
        <td>{{ props.item.sync_at }}</td>
      </template>
    </v-data-table>

  </v-container>
</template>


<script>

import moment from 'moment'
import axios from 'axios';



export default {
  components: {

  },
  data: () => ({
    searched : false,
    filter : {},
    items : [],
    loading: false,
    headers: [
      { text: 'Empresa', value: 'companyName' },
      { text: 'Nombre', value: 'full_name' },
      { text: 'Rut', value: 'rut' },
      { text: 'E-mail', value: 'email' },
      { text: 'Sincronizador el', value: 'sync_at' },
    ],
  }),
  watch: {

  },
  created(){

  },
  mounted () {
    axios.defaults.headers.post['Accept'] = 'application/json';
    axios.defaults.baseURL = localStorage.getItem('ipApiServer');
    axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');

    this.getInstallationPersonalInfo();
  },
  methods: {
    getInstallationPersonalInfo(){
      let $this = this;
      let params = Object.assign(this.filter);
      $this.loading = true;
      axios.get( 'admin/getInstallationPersonalInfo', { params : params } )
           .then( function(response){
             $this.items = response.data;
             $this.loading = false;
           })
           .catch(error => {
             if(error.response.status == 422){
               window.getApp.$emit('APP_BAD_REQUEST', error.response.data.message);
             }
           });
    }
  }

};

</script>
